import { createIcon } from "@codeArt/components/common";
import { getThemeColorValue } from "@codeArt/components/theme/color";
import { requestUrl } from "@codeArt/utils/url";
import PageLoader from "@jumbo/components/PageComponents/PageLoader";
import { makeStyles } from "@material-ui/core";
import React, {
  Suspense,
  useEffect,
  useImperativeHandle,
  useRef,
  useState
} from "react";
import { Redirect, Route, Switch, withRouter } from "react-router";
import Router from "@codeArt/electron/renderer/router";
import { NavLink } from "react-router-dom";
import { PageHeader } from ".";

const useStyles = makeStyles(theme => ({
  tab: {
    "& .multiPage--tab-item": {
      color: theme.ca.multiPage.text,
      fontSize: "0.98rem",
      margin: "0.6rem 0.1rem",
      padding: "0.3rem 1.5rem",
      minWidth: "auto !important",
      minHeight: "auto !important",
      borderRadius: "5rem !important"
    },
    "&.active .multiPage--tab-item": {
      color: theme.ca.multiPage.text_active,
      background: theme.ca.multiPage.item_active_bg
    }
  }
}));

const MultiPage = withRouter(({ getItems, match, history,header }) => {
  MultiPage.current = {
    setTools: tools => {
      tabs.current.setTools(tools);
    }
  };

  const items = getItems({ match });

  let tabs = useRef();

  return (
    <div className="d-flex flex-column h-100 w-100">
      <Tabs items={items} match={match} history={history} ref={tabs} narrow={header?.narrow} tools={header?.right} />
      <Body items={items} match={match} />
    </div>
  );
});

export default MultiPage;

const Tabs = React.forwardRef(({ items, match, history,narrow,tools:_tools }, ref) => {
  const classes = useStyles();
  const [tools, setTools] = useState(_tools);

  useImperativeHandle(ref, () => ({
    setTools
  }));

  const title = (
    <div className={`d-flex flex-row`}>
      {items.map(({ icon, title, path }, index) => {
        return (
          <NavLink key={`tab-${index}`} className={classes.tab} to={path}>
            <div className="multiPage--tab-item d-flex flex-row justify-content-start align-items-center c-pointer">
              {createIcon(icon, "c-icon-s2 mr-1")}
              <p className="mb-0 c-text-s1d5">{title}</p>
            </div>
          </NavLink>
        );
      })}
    </div>
  );

  return <PageHeader title={title} right={tools} narrow={narrow} />;
});

const Body = ({ items, match }) => {
  let first = items.length > 0 ? items[0] : null;
  const rootUrl = requestUrl(match.url);
  return (
    <div className="d-flex flex-column c-flex-1">
      <Suspense fallback={<PageLoader />}>
        <Router>
          <Switch>
            {items.map(({ path, component }, index) => {
              return (
                <Route
                  key={`tab-body-${index}`}
                  path={path}
                  component={component}
                />
              );
            })}
            {/* 设置默认第一项 */}
            {first ? (
              <Redirect exact from={`${rootUrl}/`} to={first.path} />
            ) : null}
            {first ? (
              <Redirect exact from={`${rootUrl}/index`} to={first.path} />
            ) : null}
          </Switch>
        </Router>
      </Suspense>
    </div>
  );
};
